import { render, staticRenderFns } from "./ProdcutAdd.vue?vue&type=template&id=7fab9987&scoped=true"
import script from "./ProdcutAdd.vue?vue&type=script&lang=js"
export * from "./ProdcutAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab9987",
  null
  
)

export default component.exports